(function () {
  'use strict';

  const PRODUCT_OPTIONS = [
    {n:'Assorted Barfi Laddu Box',v:'Standard box',p:695},
    {n:'Kheer Kodom',v:'10 Pcs Box',p:675},{n:'Kheer Kodom',v:'16 Pcs Box',p:1025},{n:'Kheer Kodom',v:'28 Pcs Box',p:1725},
    {n:'Kesar Pista Motichoor Laddu Box',v:'12 Pcs Box',p:725},{n:'Kesar Pista Motichoor Laddu Box',v:'16 Pcs Box',p:925},{n:'Kesar Pista Motichoor Laddu Box',v:'28 Pcs Box',p:1545},
    {n:'Assorted Barfi Box (435 gm)',v:'435 gm',p:1295},{n:'Assorted Dry Fruit Box (400 gm)',v:'400 gm',p:1095},
    {n:'Assorted Sondesh Box',v:'10 Pcs Box',p:695},{n:'Assorted Sondesh Box',v:'16 Pcs Box',p:1095},{n:'Assorted Sondesh Box',v:'28 Pcs Box',p:1795},
    {n:'Assorted Kheer Kodom Box',v:'12 Pcs Box',p:875},{n:'Assorted Kheer Kodom Box',v:'16 Pcs Box',p:1145},{n:'Assorted Kheer Kodom Box',v:'28 Pcs Box',p:1795},
    {n:'Nolen Gurer Karapak Sondesh',v:'10 Pcs Box',p:795},{n:'Nolen Gurer Sondesh Box',v:'16 Pcs',p:1195},
    {n:'Kheer Kodom Box',v:'20 Pcs',p:1295},{n:'Kesar Pista Laddu Box',v:'12 Pcs',p:725},{n:'Kaju Barfi Box (600gm)',v:'36 Pcs',p:1175},
    {n:'Dry Fruit Delights Box (19 Pcs)',v:'19 Pcs',p:1375},{n:'Kheer Kodom Box',v:'9 Pcs',p:625},
    {n:'All Time Best (9 Pcs)',v:'9 Pcs',p:675},{n:'Assorted Chocolate Box',v:'9 Pcs',p:695},{n:'Nolen Gurer Sondesh Box',v:'6 Pcs',p:545},{n:'Kaju Barfi Box',v:'9 Pcs',p:375}
  ];

  const money = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;
  const escapeHtml = (s) => String(s ?? '').replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));

  function init(root) {
    if (!root || root.dataset.sbInitialized === 'true') return;
    const modal = root.querySelector('[data-sb-modal]');
    const form = root.querySelector('[data-sb-form]');
    const items = root.querySelector('[data-sb-items]');
    const summary = root.querySelector('[data-sb-summary]');
    const success = root.querySelector('[data-sb-success]');
    const successMessage = success?.textContent?.trim() || 'Thank you. Your requirement has been submitted successfully. Our team will contact you shortly.';
    const errorBox = root.querySelector('[data-sb-error]');
    const endpoint = root.dataset.sbEndpoint || '/apps/sweetbengal-orders/order-request';
    if (!modal || !form || !items || !summary) return;
    root.dataset.sbInitialized = 'true';
    let lastTrigger = null;
    const tokenStorageKey = `sb-order-request-token:${window.location.pathname}`;
    let submissionToken = '';

    function getSubmissionToken() {
      if (submissionToken) return submissionToken;
      try {
        submissionToken = sessionStorage.getItem(tokenStorageKey) || '';
        if (!submissionToken) {
          submissionToken = (window.crypto && typeof window.crypto.randomUUID === 'function')
            ? window.crypto.randomUUID()
            : `sb-${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
          sessionStorage.setItem(tokenStorageKey, submissionToken);
        }
      } catch (_) {
        submissionToken = (window.crypto && typeof window.crypto.randomUUID === 'function')
          ? window.crypto.randomUUID()
          : `sb-${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
      }
      return submissionToken;
    }

    function clearSubmissionToken() {
      try { sessionStorage.removeItem(tokenStorageKey); } catch (_) {}
      submissionToken = '';
    }

    // Success URL markers are added only after the server confirms the request.
    // The URL change does not reload the live storefront or interrupt the modal.
    const SUCCESS_STATUS_PARAM = 'sb_order_status';
    const SUCCESS_ID_PARAM = 'sb_order_success_id';

    function makeTrackingId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return `sb-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
    }

    function updateSuccessUrl(status, trackingId) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set(SUCCESS_STATUS_PARAM, status);
        if (trackingId) url.searchParams.set(SUCCESS_ID_PARAM, trackingId);
        else url.searchParams.delete(SUCCESS_ID_PARAM);
        // Preserve history state owned by Shopify/theme scripts.
        window.history.pushState(
          window.history.state,
          '',
          `${url.pathname}${url.search}${url.hash}`
        );
      } catch (error) {
        // URL tracking must never stop a confirmed submission from showing success.
        console.warn('SweetBengal: could not update the success URL.', error);
      }
    }

    function clearPreviousSuccessUrl() {
      try {
        const url = new URL(window.location.href);
        if (!url.searchParams.has(SUCCESS_STATUS_PARAM) && !url.searchParams.has(SUCCESS_ID_PARAM)) return;
        url.searchParams.delete(SUCCESS_STATUS_PARAM);
        url.searchParams.delete(SUCCESS_ID_PARAM);
        window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
      } catch (_) {
        // Keep form submission working even if URL cleanup is unavailable.
      }
    }

    function restoreSuccessFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const status = params.get(SUCCESS_STATUS_PARAM);
      if (status !== 'success' && status !== 'already_received') return;

      // This restores the visible confirmation when someone opens or refreshes
      // a generated success URL. It intentionally does NOT fire a conversion event.
      modal.hidden = false;
      document.documentElement.classList.add('sb-no-scroll');
      document.body.classList.add('sb-no-scroll');
      success.hidden = false;
      errorBox.hidden = true;
      errorBox.textContent = '';
      success.textContent = status === 'already_received'
        ? `Your order request has already been received. ${successMessage}`
        : successMessage;
    }

    function trackConfirmedSubmission(data) {
      const isDuplicate = Boolean(data && data.duplicate);
      const status = isDuplicate ? 'already_received' : 'success';
      const trackingId = isDuplicate ? '' : makeTrackingId();
      updateSuccessUrl(status, trackingId);

      // Prefer this event in Google Tag Manager / analytics. It is pushed only
      // after the endpoint confirms success and is not pushed again on refresh.
      if (!isDuplicate) {
        // Analytics must never turn a server-confirmed submission into a UI error.
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'sb_order_request_success',
            form_name: 'seasonal_order_request',
            conversion_status: 'success',
            submission_tracking_id: trackingId
          });
        } catch (trackingError) {
          console.warn('SweetBengal: conversion tracking could not be queued.', trackingError);
        }
      }
    }

    function optionHtml() {
      return PRODUCT_OPTIONS.map((o, i) => `<option value="${i}">${escapeHtml(o.n)} - ${escapeHtml(o.v)} (${money(o.p)})</option>`).join('');
    }

    function updateSummary() {
      const selected = [...items.children].map(row => {
        const select = row.querySelector('[data-sb-product]');
        const qtyInput = row.querySelector('[data-sb-qty]');
        if (!select || select.value === '') return null;
        const qty = Math.max(1, Math.min(9999, parseInt(qtyInput?.value || '1', 10) || 1));
        const o = PRODUCT_OPTIONS[Number(select.value)];
        const total = qty * o.p;
        row.querySelector('[data-sb-price]').value = money(o.p);
        row.querySelector('[data-sb-line-total]').textContent = `Line total: ${money(total)}`;
        return {catalogId:Number(select.value), name:o.n, variant:o.v, quantity:qty, unitPrice:o.p, lineTotal:total};
      }).filter(Boolean);
      if (!selected.length) {
        summary.textContent = 'Please add at least one item and quantity.';
        return selected;
      }
      summary.textContent = selected.map(o => `${o.name} | ${o.variant} | Qty: ${o.quantity} | Unit: ${money(o.unitPrice)} | Total: ${money(o.lineTotal)}`).join('\n') + `\n\nGrand Total: ${money(selected.reduce((sum, o) => sum + o.lineTotal, 0))}`;
      return selected;
    }

    function addRow() {
      const row = document.createElement('div');
      row.className = 'sb-item-row';
      row.innerHTML = `<div class="sb-field"><label>Item</label><select data-sb-product><option value="">Select an item</option>${optionHtml()}</select></div><div class="sb-field"><label>Qty</label><input type="number" min="1" max="9999" step="1" value="1" data-sb-qty></div><div class="sb-field"><label>Unit Price</label><input type="text" data-sb-price readonly placeholder="-" /></div><div><button class="sb-remove" type="button" aria-label="Remove item">×</button></div><div class="sb-item-total" data-sb-line-total></div>`;
      items.appendChild(row);
      row.querySelector('[data-sb-product]').addEventListener('change', updateSummary);
      row.querySelector('[data-sb-qty]').addEventListener('input', updateSummary);
      row.querySelector('.sb-remove').addEventListener('click', () => { row.remove(); updateSummary(); });
      updateSummary();
    }

    function open(event) {
      lastTrigger = event?.currentTarget || root.querySelector('[data-sb-open]');
      modal.hidden = false;
      document.documentElement.classList.add('sb-no-scroll');
      document.body.classList.add('sb-no-scroll');
      if (!items.children.length) addRow();
      setTimeout(() => root.querySelector('input[name="name"]')?.focus(), 30);
    }
    function close() {
      modal.hidden = true;
      document.documentElement.classList.remove('sb-no-scroll');
      document.body.classList.remove('sb-no-scroll');
      lastTrigger?.focus();
    }
    function showError(message) { errorBox.textContent = message; errorBox.hidden = false; }
    function clearMessages() { success.hidden = true; errorBox.hidden = true; errorBox.textContent = ''; }

    root.querySelectorAll('[data-sb-open]').forEach(button => button.addEventListener('click', open));
    root.querySelectorAll('[data-sb-close]').forEach(button => button.addEventListener('click', close));
    root.querySelector('[data-sb-add]')?.addEventListener('click', addRow);
    modal.addEventListener('click', e => { if (e.target === modal) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !modal.hidden) close(); });

    root.querySelectorAll('[data-sb-quick-add]').forEach(button => {
      button.addEventListener('click', () => {
        const catalogId = String(button.getAttribute('data-sb-quick-add') || '');
        open({ currentTarget: button });
        let targetRow = [...items.children].find(row => {
          const select = row.querySelector('[data-sb-product]');
          return select && select.value === '';
        });
        if (!targetRow) {
          addRow();
          targetRow = items.lastElementChild;
        }
        const select = targetRow?.querySelector('[data-sb-product]');
        if (select && PRODUCT_OPTIONS[Number(catalogId)]) {
          select.value = catalogId;
          updateSummary();
          targetRow.querySelector('[data-sb-qty]')?.focus();
        }
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      clearMessages();
      // Do not leave a previous success marker in the URL if this attempt fails.
      clearPreviousSuccessUrl();
      const selected = updateSummary();
      if (!selected.length) { showError('Please add at least one item and quantity.'); return; }
      if (!form.reportValidity()) return;

      const cityValue = String(form.querySelector('[name="city"]')?.value || '').trim();
      if (cityValue !== 'Mumbai' && cityValue !== 'Pune') {
        showError('Delivery is available only in Mumbai and Pune. Please select one of these cities.');
        form.querySelector('[name="city"]')?.focus();
        return;
      }
      const stateValue = String(form.querySelector('[name="state"]')?.value || '').trim();
      if (stateValue !== 'Maharashtra') {
        showError('Seasonal delivery is available only in Maharashtra.');
        form.querySelector('[name="state"]')?.focus();
        return;
      }

      const payload = new FormData(form);
      // Remove the legacy "website" honeypot field: some browsers/autofill tools
      // populate it even when it is visually hidden, causing false 400 responses.
      // New forms use the less-autofill-prone sb_trap_field checked by the backend.
      payload.delete('website');
      payload.set('items_json', JSON.stringify(selected));
      payload.set('submission_token', getSubmissionToken());
      const submitButton = form.querySelector('.sb-submit');
      if (submitButton) { submitButton.disabled = true; submitButton.dataset.originalText = submitButton.textContent || ''; submitButton.textContent = 'SENDING…'; }

      try {
        const response = await fetch(endpoint, { method: 'POST', body: payload, credentials: 'same-origin', headers: {'Accept':'application/json'} });
        const contentType = (response.headers.get('content-type') || '').toLowerCase();
        let data = {};
        if (contentType.includes('application/json')) {
          data = await response.json().catch(() => ({}));
        } else {
          const responseText = await response.text().catch(() => '');
          if (!response.ok) {
            throw new Error(responseText.trim() || `The server rejected the request (HTTP ${response.status}). Please try again.`);
          }
          throw new Error(`The server returned an unexpected response (HTTP ${response.status}). Please reload the page and try again.`);
        }
        if (!response.ok || !data.ok) {
          const serverMessage = data.message || (Array.isArray(data.errors) ? data.errors.join(' ') : '');
          throw new Error(serverMessage || `Unable to submit the request (HTTP ${response.status}). Please try again.`);
        }
        success.hidden = false;
        form.reset();
        items.innerHTML = '';
        updateSummary();
        success.textContent = `${data.duplicate ? 'Your order request has already been received. ' : ''}${successMessage}${data.requestId ? ` Reference: ${data.requestId.slice(-8).toUpperCase()}.` : ''}`;
        clearSubmissionToken();
        trackConfirmedSubmission(data);
      } catch (error) {
        showError(error instanceof Error ? error.message : 'Unable to submit the request. Please try again.');
      } finally {
        if (submitButton) { submitButton.disabled = false; submitButton.textContent = submitButton.dataset.originalText || 'SEND ORDER REQUEST'; }
      }
    });

    // If a customer opens the generated success URL directly, restore the
    // confirmation UI without submitting again or emitting a conversion event.
    restoreSuccessFromUrl();
  }

  function boot(scope) {
    const context = scope || document;
    if (context.matches?.('[data-sb-root]')) init(context);
    context.querySelectorAll?.('[data-sb-root]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', () => boot(document));
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();